<!-- Component that implements a list of documents -->
<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <v-card>

          <!-- Título da tela -->
          <basic-toolbar :title="'Meus Projetos'"></basic-toolbar>

          <!-- Botões "Importar do SIEX" e "Duplicar Ação" e caixa de pesquisa -->
          <v-card-title>
            <v-btn color="primary" @click="importarProjeto">Importar do SIEX</v-btn>
            <div style="padding-left: 5px;"></div>
            <v-btn color="primary" @click="duplicarProjeto">Duplicar Ação</v-btn>
            <div style="padding-left: 30px;"></div>
            <v-checkbox
            v-model="participacoesAtivas"
            label="Mostrar apenas participações ativas"
            @change="controlaParticipacoesAtivas"
            ></v-checkbox>
            <v-spacer></v-spacer>
            <v-text-field append-icon="filter_list" label="Filtrar resultados" v-model="search"></v-text-field>
          </v-card-title>

          <!-- Tabela com ações de extensão -->
          <v-data-table
          :headers="headers"
          :items="listaMeusProjetos"
          :search="search"
          :no-data-text="'Você não participa de nenhum projeto'"
          must-sort
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :items-per-page="itemsPerPage"
          :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
          >
            <template v-slot:item.titulo="props">
              <router-link target="_blank" :to="{ name: 'ProjetoFormulario', params: { idProjeto: props.item.idProjeto }}">{{props.item.titulo}}</router-link>
            </template>
            <template v-slot:item.nomeUnidade="props">{{unidade.format(props.item.nomeUnidade,props.item.siglaUnidade)}}</template>
            <template v-slot:item.dataInicio="props">{{dates.format(props.item.dataInicio)}}</template>
            <template v-slot:item.dataConclusao="props">{{dates.format(props.item.dataConclusao)}}</template>
            <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
              Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaMeusProjetos.length }} projetos
            </template>
          </v-data-table>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
import dates from '@/utils/dates'
import unidade from '@/utils/unidade'
import projetos from '@/utils/projetos'
import { mapActions } from 'vuex'

export default {
  data: () => ({
    listaMeusProjetos: [],
    dates: dates,
    participacoesAtivas: false,
    unidade: unidade,
    search: null,
    sortBy: 'dtCriacao',
    sortDesc: true,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Número', align: 'center', value: 'idProjeto' },
      { text: 'Título', align: 'center', value: 'titulo' },
      { text: 'Unidade', align: 'center', value: 'nomeUnidade' },
      { text: 'Classificação Secundária', align: 'center', value: 'classificacaoSecundaria' },
      { text: 'Início', align: 'center', value: 'dataInicio' },
      { text: 'Término', align: 'center', value: 'dataConclusao' },
      { text: 'Situação', align: 'center', value: 'situacao' },
      { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' }
    ]
  }),
  props: ['items'],
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']),
    // Controla a exibição das ações de extensão do usuário.
    controlaParticipacoesAtivas: function () {
      if (this.participacoesAtivas) {
        this.carregaParticipacoesAtivas()
      } else {
        this.carregaParticipacoes()
      }
    },
    truncate (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    importarProjeto: function () {
      this.$router.push({name: 'ImportarProjeto'})
    },
    duplicarProjeto: function () {
      this.$router.push({name: 'DuplicarProjeto'})
    },
    carregaParticipacoes: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos.' })
      projetos.getMeusProjetos()
      .then(response => {
        this.listaMeusProjetos = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos.' })
      })
    },
    carregaParticipacoesAtivas: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos.' })
      projetos.getMeusProjetosAtivos()
      .then(response => {
        this.listaMeusProjetos = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos.' })
      })
    }
  },
  mounted () {
    this.carregaParticipacoes()
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'tooltip': ToolTip
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// meus-projetos.vue?c9d90972